module.exports = __webpack_public_path__ + "static/media/blurredtextsm.0e1cabf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blurredtextsm.png
// module id = 1901
// module chunks = 2